import React from 'react';

import { Flex } from 'src/common/components/flex/flex';
import { Text } from 'src/common/components/text/text';

import './limited-time-decorator.css';

export const LimitedTimeDecorator: React.FC = ({ children }) => (
  <Flex className="limited-time-decorator">
    <Flex
      alignItems="center"
      className="limited-time-decorator__ribbon-container"
    >
      <Text className="limited-time-decorator__ribbon-container__text">
        Limited offer 25% off
      </Text>
    </Flex>
    {children}
  </Flex>
);
